import { render } from "./login.vue?vue&type=template&id=1a5031cc&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=1a5031cc&lang=scss&scoped=true"

import exportComponent from "E:\\workspace\\symbolEnglish\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5031cc"]])

export default __exports__